<template>
  <v-app>
    <cabecerados/>
    <v-main>
      <v-container>
        <v-row class="text-center">
          <v-col cols="12">
            <section id="eventos">
              <v-row  class="text-center">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <h1 class="display-1 font-weight-bold">Carnet {{negocio.negocio}}</h1>
                </v-col>
              </v-row>
              <v-row justify="center" >

                <v-col cols="12" lg="8" sm="12"   >
                  <v-card    elevation="10">
                    <v-card-title   ></v-card-title>
                    <v-card-text >
                      <v-row justify="center" align="center">


                       <v-col cols="12">
                        <v-text-field label="Ingresa Correo Electrónico" v-model="email"></v-text-field>
                      </v-col>
                        <v-col cols="12">
                        <v-text-field label="Ingresa DNI" v-model="dni"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-alert
                              :value="alerterror"
                              color="red"
                              dark
                              dismissible
                              border="top"
                              transition="scale-transition"
                          >
                            {{errorcon}}
                          </v-alert>
                        </v-col>
                        <v-col cols="3">

                            <v-btn @click="buscar">Buscar</v-btn>
                        </v-col>

                      </v-row>

                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </section>


          </v-col>
        </v-row>
        <img :src="output">

      </v-container>
    </v-main>
    <piepagina/>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>
<script>
import piepagina from "@/components/general/piepagina";
import axios from "axios";
import Cabecerados from "@/components/general/cabecerados";

export default {
  name: 'buscacarnet',
  title: 'Carnet | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerados,
    piepagina
  },
  data () {
    return {
      overlay:false,
      alerterror: false,
      error:''   ,
      output: null,
      styleCarnet: {
        backgroundColor: 'black',
        color:'white',
        backgroundImage:'',
        backgroundSize: 'cover'
      },
      token:'',
      idpersona:0,
      errorcon:'',
      encodedPdf: "",
      email:'',
      dni:'',
      idnegocio:'',
      negocio:{}
    }
  },
  mounted() {
    this.idnegocio = this.$route.params.idnegocio
    this.damenegocio()

  },
  methods:{
    damenegocio(){
      this.overlay = true;
      axios
          .get('negocios/tag/'+this.idnegocio)
          .then(response => {
            this.overlay = false
            this.negocio = response.data;

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
          });
    },
    buscar() {

      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append("dni", this.dni);
      bodyFormData.append("email", this.email);
      bodyFormData.append("negocioId", this.negocio.id)
      axios
          .post('membresia/buscacarnet',bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {

            this.overlay = false
        this.$router.push({path:'/micarnet/'+response.data.codigoUnico})
      })
          .catch(error => {
            this.overlay = false;
            this.errorcon = "Hubo un problema con su busqueda, puede que no exista o se encuentre pendiente de aprobación."
            this.alerterror = true
            console.log(error);
          });
    }
  }
}
</script>